module.exports = __webpack_public_path__ + "static/media/forest.b219bd25.jpg";